export default {
    HEADER_TOKEN: 'O-Access-Token',
    LOGIN_DATA: 'LOGIN_DATA',
}